import React, {useEffect, useState} from "react";
import _ from "lodash";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {BLOG_POST_INPUT_FIELDS, MULTIPLE_BLOG_POST_INPUT_FIELDS} from "../../constants/blog.constant";
import {addMultipleBlogPosts} from "../../services/blog-post-data-service";
import {prepareTextListForSearch} from "../../../common/utils/text-util";
import {processBlogPostCategoryConfig} from "../../utils/blog-util";
import {updateSingleContentConfig} from "../../services/content-config-data-service";

const AddMultipleBlogPosts = ({refreshBlogPostList, blogPostCategoryConfig, setBlogPostCategoryConfig}) => {
    const [showModal, setShowModal] = useState(false);
    const [blogPostList, setBlogPostList] = useState(null);
    const [blogPostDetail, setBlogPostDetail] = useState({});
    const [saveInProgress, setSaveInProgress] = useState(false);

    useEffect(() => {
        if (showModal) {
            setBlogPostDetail({});
            setBlogPostList(null);
        }
    }, [showModal])

    const handleConfirmAction = async () => {
        setSaveInProgress(true);
        const newBlogPostList = prepareBlogPostList();

        await addMultipleBlogPosts(newBlogPostList);
        await updateBlogPostCategoryConfig();

        setSaveInProgress(false);
        refreshBlogPostList();
        setShowModal(false);
    }

    const updateBlogPostCategoryConfig = async () => {
        const existingBlogPostDetail: any = {...blogPostDetail};
        processBlogPostCategoryConfig(blogPostCategoryConfig, existingBlogPostDetail.category);
        await updateSingleContentConfig(blogPostCategoryConfig);
        setBlogPostCategoryConfig(blogPostCategoryConfig);
    }

    const handleBlogPostChanges = (event) => {
        const {name, value, type} = event.target;
        const existingBlogPostDetail = {...blogPostDetail};

        if (type === 'checkbox') {
            existingBlogPostDetail[name] = !existingBlogPostDetail[name];
        } else if (type === 'number') {
            existingBlogPostDetail[name] = _.parseInt(value);
        } else {
            existingBlogPostDetail[name] = value;
        }

        prepareBlogPostDetail(existingBlogPostDetail);
        /*if (name === 'titles') {
            prepareBlogPostList(value, existingBlogPostDetail);
        }*/

        setBlogPostDetail(existingBlogPostDetail);
    }

    const prepareBlogPostDetail = (existingBlogPostDetail) => {
        _.forEach(BLOG_POST_INPUT_FIELDS, (field: any) => {
            if (!_.isEmpty(field.default) && _.isEmpty(existingBlogPostDetail[field.attribute])) {
                existingBlogPostDetail[field.attribute] = field?.default || '';
            }
        });
    }

    const prepareBlogPostList = () => {
        const existingBlogPostDetail: any = {...blogPostDetail};

        const inputTextItems = _.split(existingBlogPostDetail.titles, '\n');
        const tempTextItemList = [];

        _.forEach(inputTextItems, (text, index) => {
            text = text.trim();

            if (text) {
                let textList = prepareTextListForSearch(text);

                tempTextItemList.push({
                    title: text,
                    textList: textList,
                    status: existingBlogPostDetail.status,
                    category: existingBlogPostDetail.category,
                });
            }
        });

        setBlogPostList(tempTextItemList);
        return tempTextItemList;
    };

    return (
        <>
            <button
                className="button-green px-3 py-2"
                onClick={() => setShowModal(true)}>
                Add Multiple Blog Posts
            </button>

            {showModal ? (
                <>
                    <div
                        className="w-full h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-full h-full">
                            {/*content*/}
                            <div
                                className="border-0 shadow-lg relative flex flex-col w-full h-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        Add Multiple Blog Posts
                                    </h3>
                                    <button
                                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                        onClick={() => setShowModal(false)}>
                                            <span
                                                className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                              ×</span>
                                    </button>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto flex flex-wrap justify-start">

                                    <div className="leading-relaxed w-1/2">
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={blogPostDetail}
                                                handleDetailChanges={handleBlogPostChanges}
                                                fieldList={_.groupBy(MULTIPLE_BLOG_POST_INPUT_FIELDS, 'group')['blog']}
                                                enableEdit={true}
                                                fieldClassName={'w-full'}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={blogPostDetail}
                                                handleDetailChanges={handleBlogPostChanges}
                                                fieldList={_.groupBy(MULTIPLE_BLOG_POST_INPUT_FIELDS, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>
                                    </div>

                                    <div className="leading-relaxed w-1/2">
                                        <div
                                            className="overflow-y-scroll h-full border border-gray-400 rounded-lg drop-shadow bg-white mx-4 px-4">
                                            <div className="text-left py-4">
                                                {blogPostList?.map((blogPost, index) => (
                                                    <div key={index}>
                                                        <span className="pl-2 pr-4">{index + 1}</span>{blogPost.title}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 mr-2 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Blog Posts
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddMultipleBlogPosts
